module.exports = __webpack_public_path__ + "static/media/app02_jpn.beb5a41b.png";